import PropTypes from 'prop-types';
import '../assets/assistantComponents.scss';

const AiAssistantButton = ({
  onClick,
  disabled = false,
  busy = false,
  label = 'Open AI Assistant',
  className = '',
  queueCount = 0,
  needsAttention = false,
  working = false,
}) => (
  <button
    className={`btn ai-assistant-button ${className}`.trim()}
    type="button"
    onClick={onClick}
    disabled={disabled || busy}
    aria-label={label}
    title={label}
  >
    {busy ? (
      <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
    ) : (
      <i className="bi bi-stars" aria-hidden="true"></i>
    )}
    {queueCount > 0 ? (
      <span className={`ai-assistant-button-status${
        needsAttention ? ' needs-attention' : working ? ' is-working' : ''
      }`}
        aria-hidden="true">{needsAttention ? '!' : queueCount}</span>
    ) : null}
  </button>
);

AiAssistantButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  busy: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  queueCount: PropTypes.number,
  needsAttention: PropTypes.bool,
  working: PropTypes.bool,
};

export default AiAssistantButton;
